module.exports = __webpack_public_path__ + "static/assets/img/remotw_work_w.7a5720b9.svg";